import { AnimatePresence, motion } from "framer-motion";
import { RainPhase, FrozenDrop, FinalStats } from "./RainEndPhase";
import { Vortex } from "./Vortex";
import { EnergyCore } from "./EnergyCore";
import { CoinBurst } from "./CoinBurst";
import { RewardScreen } from "./RewardScreen";
import { AwardFeed } from "./AwardFeed";
import { RainContributor } from "./useRainWebSocket";

interface RainStageProps {
  phase: RainPhase;
  frozenDrops: FrozenDrop[];
  finalStats: FinalStats;
  contributors: RainContributor[];
  topContributors?: {
    twitch_id: string;
    twitch_name: string;
    totalContributed: number;
  }[];
}

export function RainStage({
  phase,
  frozenDrops,
  finalStats,
  contributors,
  topContributors,
}: RainStageProps) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={phase}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.15 }}
        style={{ position: "absolute", inset: 0 }}
      >
        {phase === "freeze" && (
          <div className="absolute inset-0">
            {/* Backdrop darkening */}
            <motion.div
              className="absolute inset-0 rounded-3xl"
              initial={{ background: "rgba(0,0,0,0)" }}
              animate={{ background: "rgba(0,0,0,0.7)" }}
              transition={{ duration: 0.2 }}
            />
            {/* Frozen drops */}
            <div className="absolute inset-0">
              {frozenDrops.map((drop) => (
                <div
                  key={drop.id}
                  style={{
                    position: "absolute",
                    left: `${drop.x}%`,
                    top: `${drop.y}%`,
                    transform: "translate(-50%, -50%)",
                    width: 40,
                    height: 40,
                  }}
                >
                  <img
                    src="/espont.png"
                    alt="espont"
                    className="w-full h-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {phase === "vortex" && <Vortex frozenDrops={frozenDrops} />}

        {phase === "energyCore" && <EnergyCore />}

        {phase === "explosion" && <CoinBurst />}

        {phase === "rewardScreen" && (
          <RewardScreen finalStats={finalStats} />
        )}

        {phase === "awardFeed" && (
          <AwardFeed
            contributors={contributors}
            finalStats={finalStats}
            topContributors={topContributors}
          />
        )}

        {phase === "fadeOut" && (
          <motion.div
            className="absolute inset-0"
            animate={{ opacity: 0 }}
            transition={{ duration: 1 }}
          />
        )}
      </motion.div>
    </AnimatePresence>
  );
}
